interface I_SearchPanelProps {
    keyword: string;
    imgUrl: string | null;
    imgUrlM: string | null;
}
declare global {
    //新增window屬性(之後可能拿掉，等搜尋面板組別更新後此處應該就不會用了)
    interface Window {
        [key: string]: any;
    }
}
export default ({
    keyword,
    imgUrlM,
    imgUrl,
}: {
    keyword: string;
    imgUrlM: string;
    imgUrl: string;
}) => {
    //傳圖的話要跟searchpanel同事確認參數
    const searchKeywordProps: I_SearchPanelProps = {
        keyword: keyword,
        imgUrl: null,
        imgUrlM: null,
    };
    if (imgUrl) searchKeywordProps.imgUrl = imgUrl;
    if (imgUrlM) searchKeywordProps.imgUrlM = imgUrlM;
    new window.SearchPanel({
        panel: 'keywordSearch',
        type: 'pc',
        // target: '_blank',
        rowSkin: true,
        mTitle: '搜尋引擎',
        // mCloseBtn: function () {
        //     console.log('close');
        // },
        // searchPaneltDidMount: function () {
        //     console.log('Search Panel ready!!');
        // },
        // whenSubmitBtnClick: function () {
        //     console.log('when Submit Button on Click!!');
        // },
        renderNode: 'searchPanel',
        language: 'zh-tw',
        searchKeywordProps,
    });
};
